import { Collapsible } from "modules/sections/Collapsible";
import type { CollapsibleProps } from "modules/sections/Collapsible";
import type { ReactStoryblokComponent } from "types/storyblok";

const CollapsibleAdapter = ({
  sbEditable,
  blok: { variant, isChat, collapsibleItems, heading },
}: ReactStoryblokComponent<CollapsibleProps>) => (
  <Collapsible
    heading={heading}
    variant={variant}
    isChat={isChat}
    collapsibleItems={collapsibleItems}
    sbEditable={sbEditable}
  />
);

export default CollapsibleAdapter;
